/** @clearscore/external-public.add-client-instance v0.10.1: 2022-12-13 16:4 (assemble v5.5.2) **/
import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import hasClientData from '@clearscore/helpers.has-client-data';
import createAxiosClients from '@clearscore/helpers.create-axios-clients';
import getEnv from '@clearscore/helpers.envs';
import getDevice from '@clearscore/helpers.device';
import { getSessionToken } from '@clearscore/helpers.session';
var clientDirectory = {
  international: {
    baseURL: getEnv('INTERNATIONAL_API_DOMAIN'),
    responseType: 'json'
  }
};
function addDeviceHeader() {
  return {
    'X-CS-Device': getDevice()
  };
}
/**
 * Get auth headers required for Caesium API requests using bearer token
 * @returns {object} auth headers
 */
function getCaesiumBearerAuth() {
  return _objectSpread({
    Authorization: "Bearer ".concat(getSessionToken())
  }, addDeviceHeader());
}

/**
 * Get auth headers required for Caesium API request
 * @param {string} client api client to match auth headers for
 * @param {object} state from the redux store
 * @returns {object} auth headers
 */
// eslint-disable-next-line no-unused-vars
function getAuth(client, state) {
  switch (client) {
    case 'international':
      return getCaesiumBearerAuth();
    default:
      return {};
  }
}
var getClient = createAxiosClients(clientDirectory);

/**
 * Add client instance to payload meta object
 * @param {object} store redux store
 * @param {object} action redux action
 * @returns {boolean} if action structure is correct
 */
function addClient(store, action) {
  var _action$payload$reque = action.payload.request,
    clientKey = _action$payload$reque.client,
    requestMeta = _action$payload$reque.meta,
    headers = _action$payload$reque.headers;
  var state = store.getState();
  var client = getClient(clientKey, state, requestMeta);
  return _objectSpread(_objectSpread({}, action), {}, {
    payload: _objectSpread(_objectSpread({}, action.payload), {}, {
      meta: _objectSpread(_objectSpread({}, action.payload.meta), {}, {
        client: client
      }),
      request: _objectSpread(_objectSpread({}, action.payload.request), {}, {
        headers: _objectSpread(_objectSpread({}, headers), getAuth(clientKey, state))
      })
    })
  });
}

/**
 * If the action payload has a client object, add the correct client instance.
 * If no client matches, fallback to the default client
 * @param {object} store redux store
 * @param {object} action redux action
 * @returns {object} action redux action
 */

function addClientInstance(store, action) {
  return hasClientData(action) ? addClient(store, action) : action;
}
var allClients = getClient;
export { allClients, addClientInstance as default };